import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { ClientService } from './../../shared/services/client.service';

@Component({
  selector: 'app-account-to-connection-dialog',
  templateUrl: './account-to-connection-dialog.component.html',
  styleUrls: ['./account-to-connection-dialog.component.scss']
})
export class AccountToConnectionDialogComponent implements OnInit {

  confirmResult: Subject<any>
  associateWallet: boolean = false
  model: any = {}
  rb_accounts: any = []
  accounts_filtered: any = []
  connections: any = []
  rb_account: any = {}
  isSubmit = false
  weight: number

  constructor(
    public modalRef: BsModalRef,
    private clientService: ClientService
  ) { }

  ngOnInit(): void {
    this.confirmResult = new Subject()
    this.filtered()
  }

  onSelectAccount(item: any) {
    this.rb_account = this.rb_accounts.find(x => x.account_uuid === item.target.value)
  }

  filtered() {
    this.accounts_filtered = this.rb_accounts.filter(item1 => !this.model.rb_accounts.some(item2 => item2.account_uuid === item1.account_uuid))
  }

  addAccount() {
    // this.rb_accounts.map(account => {
    //   if (account.uuid === this.rb_account_uuid) {
    //     account.connections = this.connections.filter(c => c.uuid === this.model.uuid)
    //   }
    //   return account
    // })
    // this.model.uuid = undefined
    // this.rb_account_uuid = undefined
  }

  async submit() {
    this.isSubmit = true
    const $res = await this.clientService.saveAccountToConnection(this.model.uuid, this.rb_account.account_uuid, { weight: this.rb_account.weight })
    this.model.rb_accounts.push(this.rb_account)
    this.rb_account = {}
    this.filtered()
  }

  close() {
    this.confirmResult.next(this.isSubmit

    )
    this.modalRef.hide()
  }
}
